@if (!criteria.BusinessId) {
<brt-business-list (selected)="router.navigate([basePath, 'promotion', $event.Id])"></brt-business-list>
}
@else {
<div class="card">
  <h5>Promotion List</h5>
  <p-table #dt1 [value]="promotions" dataKey="id" [rows]="100" [loading]="loading" [rowHover]="true"
    styleClass="p-datatable-gridlines" [paginator]="true" [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
    [totalRecords]="total" [globalFilterFields]="[]" responsiveLayout="scroll" [lazy]="true" (onLazyLoad)="load($event)"
    (onRowReorder)="setOrder()">
    <ng-template pTemplate="caption">
      <div class="flex sm:flex-row">
        <button pButton label="Add" class="p-button-outlined mr-2" icon="pi pi-plus"
          [routerLink]="[basePath, 'promotion',criteria.BusinessId,'add']"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 12rem">
          <div class="flex justify-content-between align-items-center">
            Name
            <p-columnFilter type="text" field="name" display="promotion" placeholder="Search by name"></p-columnFilter>
          </div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">Description</div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">Actions</div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-promotion let-index="rowIndex">
      <tr [pReorderableRow]="index">
        <td>
          <span class="pi pi-bars mr-2" pReorderableRowHandle></span>
          <img [src]="promotion.UI?.Image" width="30">
          <span class="image-text ml-2">{{promotion.Name}}</span>
        </td>
        <td>
          <span class="image-text ml-2">{{promotion.UI?.Description}}</span>
        </td>
        <td>
          <button pButton class="p-button-outlined mr-2" icon="pi pi-pencil" title="Edit"
            [routerLink]="[basePath, 'promotion', criteria.BusinessId, promotion.Id]"></button>
          <button (click)="removePromotion(promotion)" pButton icon="pi pi-trash" title="Delete"
            class="p-button-danger mr-2"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No promotion found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="8">Loading promotion data. Please wait.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmPopup key="confirmPopup"></p-confirmPopup>}